import {addValidator, confirmation} from 'redux-form-validators';

export const MIN_PASSWORD_LENGTH = 6;

export const confirm = opts =>
  confirmation({
    message: {
      id: 'validation.password_not_match'
    },
    ...opts
  });

/* eslint-disable consistent-return */
export default addValidator({
  validator: (options, value) => {
    const minLength = options.minLength || MIN_PASSWORD_LENGTH;

    if (value.length < minLength) {
      return {
        id: 'validation.min_length',
        values: {
          length: minLength
        }
      };
    }
  }
});
/* eslint-enable consistent-return */



// WEBPACK FOOTER //
// ./validators/units/password.js